// extracted by mini-css-extract-plugin
export default {"breadcrumb__container":"BreadCrumb_breadcrumb__container__GwObA","remainingTitle":"BreadCrumb_remainingTitle__oWYKA"};